import * as React from 'react';
import { ApplicationState, FormState } from '../models/ApplicationState';
import { connect } from 'react-redux';
import { Dispatch } from 'redux';
import { Form } from '@formio/react';
import { FormActionType, LoadFormPayload, SubmissionRequestPayload } from '../models/SubmissionModel';
import { saveFormData, updateForm, loadFormData } from './../state/form/formDataActions';
import FormLoader from './FormLoader';

export interface DispatchProps {
    loadFormData: (data: LoadFormPayload) => void;
    saveFormData: (data: SubmissionRequestPayload) => void;
    updateFormData: (data: any) => void;
}
export interface OwnProps {
    formAlias: string;
    formJsonDefinition?: any;
    version: number;
    submissionUrl?: string;
    loadFormStructure?: (data: string, version: number) => void;
    submission?: any;
    formHeader: string;
    action?: FormActionType;
    options: {
        readOnly: boolean;
        noAlerts: boolean;
        hide: boolean;
        i18n: any;
        language: string;
    }
    onSubmit?: (data: any) => void;
    handleCustomEvent?: (data: any) => void;
    handleOnFormChange?: (data: any) => void;
}
class FormComponent extends React.PureComponent<FormState & DispatchProps & OwnProps> {
    public formSubmission: any;
    public formOptions: any;
    public formData: any;
    public options: any;
    public constructor(props: any) {
        super(props);
        this.options = {};
    }
    public UNSAFE_componentWillMount() {
        if (!this.props.formJsonDefinition) {
            this.loadFormData();
        }
        this.options = {
            ...this.props.options
        }
    }
    public UNSAFE_componentWillReceiveProps(newProps: any) {
        if (newProps.options.language) {
            this.options = {
                ...this.props.options,
                language: newProps.options.language
            }
        }
    }

    public render() {
        let formData: any;
        let formOptions: any;
        this.options = {
            ...this.props.options
        }
        if (this.props.formJsonDefinition) {
            this.options.i18n = (this.props.formJsonDefinition.i18n) ? this.props.formJsonDefinition.i18n : {};
            formData = JSON.parse(JSON.stringify(this.props.formJsonDefinition));
            formOptions = this.options ? JSON.parse(JSON.stringify(this.options)) : {};
        } else {
            this.options.i18n = this.props.applicationFormData[this.props.formAlias] ?
                this.props.applicationFormData[this.props.formAlias].i18n : {};
            formData = JSON.parse(JSON.stringify(this.props.applicationFormData))[this.props.formAlias];
            formOptions = this.options ? JSON.parse(JSON.stringify(this.options)) : {};
        }
        return (<div>
            <h2>{this.props.formHeader}</h2>
            {
                this.props.formDataLoading ? <FormLoader /> : <Form
                    key={this.props.formAlias}
                    options={formOptions}
                    form={this.props.formJsonDefinition || formData}
                    submission={this.props.submission || {}}
                    onSubmit={this.props.onSubmit || this.onSubmit}
                    onCustomEvent={this.props.handleCustomEvent}
                    onChange={this.props.handleOnFormChange}
                />
            }
        </div>);
    }
    private loadFormData = () => {
        this.props.loadFormData({
            formAlias: this.props.formAlias,
            version: this.props.version
        });
    }
    private onSubmit = (data: any) => {
        switch (this.props.action) {
            case FormActionType.CREATE: this.props.saveFormData({
                formAlias: this.props.formAlias,
                formData: data,
                submissionUrl: this.props.submissionUrl
            });
                break;
            case FormActionType.UPDATE: this.props.updateFormData({
                loadFormData: {
                    formAlias: this.props.formAlias,
                    submissionUrl: this.props.submissionUrl
                },
                payload: data,
            });
                break;
            default: this.props.saveFormData({
                formAlias: this.props.formAlias,
                formData: data,
                submissionUrl: this.props.submissionUrl
            });
        }
    }
}
const mapStateToProps = (state: ApplicationState): FormState => state.formState;
const mapDispactToProps = (dispatch: Dispatch<any>): DispatchProps => ({
    loadFormData: (data: LoadFormPayload) => dispatch(loadFormData(data)),
    saveFormData: (data: SubmissionRequestPayload) => dispatch(saveFormData(data)),
    updateFormData: (data: any) => dispatch(updateForm(data))
});
export default connect(mapStateToProps, mapDispactToProps)(FormComponent);